export const invitadoVacio = {
    turnoID: 0,
    dni: '',
    nombre: '',
    apellido: '',
    edad: '',
    estaActivo: true
}